var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main page-inside faq-page"},[_c('div',{staticClass:"main-wrapper"},[(_vm.$parent.faq && _vm.$parent.faq.length)?_c('FaqSection',{attrs:{"faq":_vm.$parent.faq}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }